export default __webpack_public_path__ + "static/media/headphones.0675ae4a.jpg";